
// import React, { useState, useRef, useEffect } from "react";
// import { GoogleMap, Marker, Autocomplete, useJsApiLoader } from "@react-google-maps/api";
// import MyLocationIcon from "@mui/icons-material/MyLocation";
// import { getEngineeringVendorById } from "../../../Service/Engineeringservicefil";
// import { useLoader } from "../../../context/LoaderProvider";

// const Profilemangement = ({ formData, setFormData, onNext }) => {
//     const [openMap, setOpenMap] = useState(false);
//     const [center, setCenter] = useState({ lat: 17.385, lng: 78.486 });
//     const [marker, setMarker] = useState(null);
//     const autoRef = useRef(null);
//     const [zoom, setZoom] = useState(13);
//     const { showLoader, hideLoader } = useLoader();
    
//     // 📍 CURRENT LOCATION
//     const { isLoaded } = useJsApiLoader({
//         googleMapsApiKey: "AIzaSyCf7bYn7iDIs2T6-sDnmr7qWy9oFZOPOuc",
//         libraries: ["places"]
//     });

//     // Helper function to safely get string value
//     const safeString = (value) => {
//         if (value === null || value === undefined) return "";
//         return String(value);
//     };

//     // Helper function to safely trim
//     const safeTrim = (value) => {
//         if (value === null || value === undefined) return "";
//         return String(value).trim();
//     };

//     // 🔥 FETCH DATA USING SERVICE FILE
//     useEffect(() => {
//         const fetchVendorData = async () => {
//             try {
//                 showLoader();
//                 const vendorId = localStorage.getItem("vendorId");
                
//                 console.log("🔍 Fetching vendor data for ID:", vendorId);
                
//                 if (!vendorId) {
//                     console.warn("No vendorId found");
//                     return;
//                 }
                
//                 // ✅ USING THE SERVICE FUNCTION
//                 const data = await getEngineeringVendorById(vendorId);
                
//                 console.log("📦 API Response:", data);
                
//                 if (data && Object.keys(data).length > 0) {
//                     // Update formData with API data
//                     setFormData(prev => ({
//                         ...prev,
//                         // Company Details
//                         companyName: safeString(data.companyName),
//                         businessVertical: safeString(data.businessVertical) || "ENGINEERING_SERVICE",
//                         position: safeString(data.position),
//                         verticalType: safeString(data.vendorType),
                        
//                         // Address Details - Convert numbers to strings
//                         doorNumber: safeString(data.doorNumber),
//                         addressLine: safeString(data.addressLine),
//                         city: safeString(data.city),
//                         state: safeString(data.state),
//                         pincode: safeString(data.pincode),  // Convert number to string
//                         landMark: safeString(data.landMark),
//                         latitude: safeString(data.latitude),
//                         longitude: safeString(data.longitude),
//                         fullAddress: safeString(data.fullAddress),
                        
//                         // Contact Details
//                         contactName: safeString(data.holderName),
//                         phone: safeString(data.mobileNumber),
//                         email: safeString(data.email),
                        
//                         // Documents
//                         aadhar: safeString(data.aadharNumber),
//                         aadharPreview: safeString(data.aadharPhotoFront),
                        
//                         pan: safeString(data.panCardNumber),
//                         panFilePreview: safeString(data.panCard),
                        
//                         gst: safeString(data.gstNumber),
//                         gstFilePreview: safeString(data.gstFile),
                        
//                         // Licenses
//                         tradeLicenseNo: safeString(data.tradeLicenseNumber),
//                         tradeStart: safeString(data.tradeLicenseStartDate),
//                         tradeEnd: safeString(data.tradeLicenseEndDate),
//                         tradeLicenseFilePreview: safeString(data.tradeLicense),
                        
//                         labourLicenseNo: safeString(data.labourLicenseNumber),
//                         labourStart: safeString(data.labourStartDate),
//                         labourEnd: safeString(data.labourEndDate),
//                         labourFilePreview: safeString(data.labourLicense),
                        
//                         // Bank Details
//                         bankName: safeString(data.bankName),
//                         ifsc: safeString(data.ifscCode),
//                         accountNumber: safeString(data.bankAccountNumber),
//                         passbookFilePreview: safeString(data.passbook)
//                     }));
                    
//                     console.log("✅ FormData populated with API data");
//                 }
                
//             } catch (error) {
//                 console.error("❌ Error fetching vendor data:", error);
//                 if (error.response?.status === 404) {
//                     console.log("No existing data - new registration");
//                 }
//             } finally {
//                 hideLoader();
//             }
//         };
        
//         fetchVendorData();
//     }, []);

//     // Debug: Log when formData changes
//     useEffect(() => {
//         console.log("📝 Current formData:", formData);
//     }, [formData]);

//     // 🔥 AUTO-GENERATE FULL ADDRESS - FIXED with safeTrim
//     useEffect(() => {
//         const addressParts = [];
        
//         const doorNo = safeTrim(formData.doorNumber);
//         const addressLine = safeTrim(formData.addressLine);
//         const landmark = safeTrim(formData.landMark);
//         const city = safeTrim(formData.city);
//         const state = safeTrim(formData.state);
//         const pincode = safeTrim(formData.pincode);
        
//         if (doorNo) addressParts.push(doorNo);
//         if (addressLine) addressParts.push(addressLine);
//         if (landmark) addressParts.push(landmark);
//         if (city) addressParts.push(city);
//         if (state) addressParts.push(state);
//         if (pincode) addressParts.push(pincode);
        
//         const fullAddress = addressParts.join(", ");
        
//         if (fullAddress !== formData.fullAddress) {
//             setFormData(prev => ({
//                 ...prev,
//                 fullAddress: fullAddress
//             }));
//         }
//     }, [formData.doorNumber, formData.addressLine, formData.landMark, formData.city, formData.state, formData.pincode]);

//     const handleCurrentLocation = () => {
//         navigator.geolocation.getCurrentPosition(async (pos) => {
//             const lat = pos.coords.latitude;
//             const lng = pos.coords.longitude;

//             setCenter({ lat, lng });
//             setMarker({ lat, lng });

//             try {
//                 const res = await fetch(
//                     `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyCf7bYn7iDIs2T6-sDnmr7qWy9oFZOPOuc`
//                 );

//                 const data = await res.json();
//                 const result = data.results[0];

//                 const getComponent = (type) =>
//                     result.address_components.find(c => c.types.includes(type))?.long_name || "";

//                 const city = getComponent("locality");
//                 const state = getComponent("administrative_area_level_1");
//                 const pincode = getComponent("postal_code");

//                 const addressParts = result.formatted_address.split(",");

//                 setFormData(prev => ({
//                     ...prev,
//                     latitude: lat,
//                     longitude: lng,
//                     fullAddress: result.formatted_address,
//                     doorNumber: addressParts[0] || "",
//                     addressLine: addressParts.slice(1, 3).join(","),
//                     landMark: addressParts[2] || "",
//                     city,
//                     state,
//                     pincode,
//                     address: city
//                 }));

//             } catch (err) {
//                 console.error(err);
//             }
//         });
//     };

//     // 🔍 SEARCH
//     const onPlaceChanged = () => {
//         const place = autoRef.current.getPlace();

//         if (place.geometry) {
//             const lat = place.geometry.location.lat();
//             const lng = place.geometry.location.lng();

//             setCenter({ lat, lng });
//             setMarker({ lat, lng });

//             setFormData(prev => ({
//                 ...prev,
//                 latitude: lat,
//                 longitude: lng,
//                 address: place.formatted_address
//             }));
//         }
//     };

//     return (
//         <div style={cardStyle}>
//             {/* Company Details Section */}
//             <div style={rowStyle}>
//                 <div style={field}>
//                     <label style={label}>Company Name *</label>
//                     <input
//                         style={input}
//                         value={formData.companyName || ""}
//                         onChange={(e) =>
//                             setFormData({ ...formData, companyName: e.target.value })
//                         }
//                         placeholder="Enter company name"
//                     />
//                 </div>

//                 <div style={field}>
//                     <label style={label}>Business Vertical *</label>
//                     <input
//                         style={{ ...input, background: "#f3f4f6" }}
//                         value="Engineering Service"
//                         readOnly
//                     />
//                 </div>
                
//                 <div style={field}>
//                     <label style={label}>Position *</label>
//                     <input
//                         style={input}
//                         value={formData.position || ""}
//                         onChange={(e) =>
//                             setFormData({ ...formData, position: e.target.value })
//                         }
//                         placeholder="Enter position"
//                     />
//                 </div>
//             </div>

//             {/* Vertical Type & Address */}
//             <div style={rowStyle}>
//                 <div style={field}>
//                     <label style={label}>Vertical Type *</label>
//                     <select
//                         style={input}
//                         value={formData.verticalType || ""}
//                         onChange={(e) =>
//                             setFormData({ ...formData, verticalType: e.target.value })
//                         }
//                     >
//                         <option value="">Select service type</option>
//                         <option value="MECHANICAL_SERVICE">Mechanical Services</option>
//                         <option value="IT_SERVICE">IT Services</option>
//                         <option value="ELECTRICAL_SERVICE">Electrical Services</option>
//                         <option value="CIVIL_SERVICE">Civil Services</option>
//                         <option value="AUTOMATION_SERVICE">Automation Services</option>
//                         <option value="MAINTENANCE_SERVICE">Maintenance Services</option>
//                     </select>
//                 </div>

//                 <div style={field}>
//                     <label style={label}>Door No</label>
//                     <input
//                         style={input}
//                         value={formData.doorNumber || ""}
//                         onChange={(e) =>
//                             setFormData({ ...formData, doorNumber: e.target.value })
//                         }
//                         placeholder="Enter door number"
//                     />
//                 </div>

//                 <div style={field}>
//                     <label style={label}>Street / Address</label>
//                     <input
//                         style={input}
//                         value={formData.addressLine || ""}
//                         onChange={(e) =>
//                             setFormData({ ...formData, addressLine: e.target.value })
//                         }
//                         placeholder="Enter street address"
//                     />
//                 </div>
//             </div>

//             <div style={rowStyle}>
//                 <div style={field}>
//                     <label style={label}>City</label>
//                     <input
//                         style={input}
//                         value={formData.city || ""}
//                         onChange={(e) =>
//                             setFormData({ ...formData, city: e.target.value })
//                         }
//                         placeholder="Enter city"
//                     />
//                 </div>
                
//                 <div style={field}>
//                     <label style={label}>State</label>
//                     <input
//                         style={input}
//                         value={formData.state || ""}
//                         onChange={(e) =>
//                             setFormData({ ...formData, state: e.target.value })
//                         }
//                         placeholder="Enter state"
//                     />
//                 </div>

//                 <div style={field}>
//                     <label style={label}>Pincode</label>
//                     <input
//                         style={input}
//                         value={formData.pincode || ""}
//                         onChange={(e) =>
//                             setFormData({ ...formData, pincode: e.target.value })
//                         }
//                         placeholder="Enter pincode"
//                     />
//                 </div>
//             </div>

//             <div style={rowStyle}>
//                 <div style={field}>
//                     <label style={label}>Landmark</label>
//                     <input
//                         style={input}
//                         value={formData.landMark || ""}
//                         onChange={(e) =>
//                             setFormData({ ...formData, landMark: e.target.value })
//                         }
//                         placeholder="Enter landmark"
//                     />
//                 </div>
                
//                 <div style={field}>
//                     <label style={label}>Latitude</label>
//                     <input
//                         style={input}
//                         value={formData.latitude || ""}
//                         onChange={(e) =>
//                             setFormData({ ...formData, latitude: e.target.value })
//                         }
//                         placeholder="Latitude"
//                     />
//                 </div>

//                 <div style={field}>
//                     <label style={label}>Longitude</label>
//                     <input
//                         style={input}
//                         value={formData.longitude || ""}
//                         onChange={(e) =>
//                             setFormData({ ...formData, longitude: e.target.value })
//                         }
//                         placeholder="Longitude"
//                     />
//                 </div>
//             </div>

//             {/* Full Address Display (Auto-generated) */}
//             {/* <div style={field}>
//                 <label style={label}>Full Address (Auto-generated)</label>
//                 <div style={{
//                     ...input,
//                     background: "#f3f4f6",
//                     minHeight: "60px",
//                     wordBreak: "break-all"
//                 }}>
//                     {formData.fullAddress || "Address will appear here automatically"}
//                 </div>
//             </div> */}

//             {/* Location Button */}
//             <div style={field}>
//                 <label style={label}>Location *</label>
//                 <button
//                     onClick={() => setOpenMap(true)}
//                     style={{
//                         width: "15%",
//                         height: "40px",
//                         background: "#2563eb",
//                         color: "#fff",
//                         borderRadius: "8px",
//                         border: "none",
//                         cursor: "pointer",
//                         fontWeight: "500"
//                     }}
//                 >
//                     📍 Add Location
//                 </button>
//             </div>

//             {/* Next Button */}
//             <div style={{ textAlign: "center", marginTop: "30px" }}>
//                 <button style={nextBtn} onClick={onNext}>
//                     Next →
//                 </button>
//             </div>
            
//             {/* MAP MODAL */}
//             {openMap && (
//                 <div style={overlayStyle} onClick={() => setOpenMap(false)}>
//                     <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
//                         <h3>Select Location</h3>

//                         {!isLoaded ? (
//                             <p>Loading map...</p>
//                         ) : (
//                             <>
//                                 <Autocomplete
//                                     onLoad={(ref) => (autoRef.current = ref)}
//                                     onPlaceChanged={onPlaceChanged}
//                                 >
//                                     <input
//                                         type="text"
//                                         placeholder="Search cities or areas..."
//                                         style={searchInput}
//                                     />
//                                 </Autocomplete>

//                                 <div style={{ position: "relative" }}>
//                                     <GoogleMap
//                                         mapContainerStyle={{ width: "100%", height: "350px" }}
//                                         center={center}
//                                         zoom={zoom}
//                                         options={{
//                                             disableDefaultUI: true,
//                                             zoomControl: false
//                                         }}
//                                         onClick={async (e) => {
//                                             const lat = e.latLng.lat();
//                                             const lng = e.latLng.lng();
//                                             setMarker({ lat, lng });

//                                             try {
//                                                 const res = await fetch(
//                                                     `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyCf7bYn7iDIs2T6-sDnmr7qWy9oFZOPOuc`
//                                                 );
//                                                 const data = await res.json();
//                                                 const result = data.results[0];
//                                                 const getComponent = (type) =>
//                                                     result.address_components.find(c => c.types.includes(type))?.long_name || "";
//                                                 const city = getComponent("locality") || getComponent("administrative_area_level_2");
//                                                 const state = getComponent("administrative_area_level_1");
//                                                 const pincode = getComponent("postal_code");
//                                                 const landmark = result.address_components[1]?.long_name || "";
//                                                 const addressParts = result.formatted_address.split(",");
//                                                 const doorNumber = addressParts[0] || "";
//                                                 const addressLine = addressParts.slice(1, 3).join(",") || "";

//                                                 setFormData(prev => ({
//                                                     ...prev,
//                                                     latitude: lat,
//                                                     longitude: lng,
//                                                     fullAddress: result.formatted_address,
//                                                     doorNumber: doorNumber,
//                                                     addressLine: addressLine,
//                                                     landMark: landmark,
//                                                     city: city,
//                                                     state: state,
//                                                     pincode: pincode,
//                                                     address: city
//                                                 }));
//                                             } catch (err) {
//                                                 console.error(err);
//                                             }
//                                         }}
//                                     >
//                                         {marker && <Marker position={marker} />}
//                                     </GoogleMap>

//                                     <div style={mapControls}>
//                                         <div style={controlBtn} onClick={() => setZoom(z => z + 1)}>+</div>
//                                         <div style={controlBtn} onClick={() => setZoom(z => z - 1)}>−</div>
//                                         <div style={controlBtn} onClick={handleCurrentLocation}>
//                                             <MyLocationIcon style={{ color: "#1a73e8", fontSize: "22px" }} />
//                                         </div>
//                                     </div>
//                                 </div>
//                             </>
//                         )}

//                         <div style={{ textAlign: "center", marginTop: "10px" }}>
//                             <button onClick={() => setOpenMap(false)} style={selectBtn}>
//                                 Save Location
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Profilemangement;

// // Styles remain the same...
// const cardStyle = {
//     background: "#fff",
//     borderRadius: "12px",
// };

// const rowStyle = {
//     display: "flex",
//     gap: "20px",
//     flexWrap: "wrap",
//     marginBottom: "15px"
// };

// const field = {
//     flex: 1,
//     minWidth: "220px"
// };

// const label = {
//     fontSize: "13px",
//     fontWeight: "600",
//     marginBottom: "6px",
//     display: "block",
//     color: "#374151"
// };

// const input = {
//     width: "100%",
//     padding: "10px",
//     borderRadius: "8px",
//     border: "1px solid #d1d5db",
//     background: "#f9fafb",
//     fontSize: "13px",
//     fontFamily: "inherit"
// };

// const nextBtn = {
//     background: "#f97316",
//     color: "#fff",
//     padding: "10px 30px",
//     borderRadius: "10px",
//     border: "none",
//     cursor: "pointer",
//     fontWeight: "600"
// };

// const overlayStyle = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     background: "rgba(0,0,0,0.4)",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     zIndex: 999
// };

// const modalStyle = {
//     width: "500px",
//     background: "#fff",
//     padding: "20px",
//     borderRadius: "12px"
// };

// const selectBtn = {
//     background: "#10b981",
//     color: "#fff",
//     padding: "8px 20px",
//     borderRadius: "8px",
//     border: "none",
//     cursor: "pointer"
// };

// const searchInput = {
//     width: "100%",
//     padding: "10px",
//     borderRadius: "20px",
//     border: "1px solid #ccc",
//     marginBottom: "10px"
// };

// const mapControls = {
//     position: "absolute",
//     right: "10px",
//     bottom: "80px",
//     display: "flex",
//     flexDirection: "column",
//     gap: "10px",
//     zIndex: 10
// };

// const controlBtn = {
//     width: "42px",
//     height: "42px",
//     background: "#fff",
//     borderRadius: "50%",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     cursor: "pointer",
//     fontSize: "18px",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
//     transition: "0.2s"
// };



import React, { useState, useEffect } from "react";
import { getEngineeringVendorById } from "../../../Service/Engineeringservicefil";
import { useLoader } from "../../../context/LoaderProvider";

const Profilemangement = ({ formData, setFormData, onNext }) => {
    const [loading, setLoading] = useState(false);
    const { showLoader, hideLoader } = useLoader();

    useEffect(() => {
        const fetchVendorData = async () => {
            try {
                showLoader();
                const vendorId = localStorage.getItem("vendorId");
                
                if (!vendorId) return;
                
                const data = await getEngineeringVendorById(vendorId);
                
                if (data && Object.keys(data).length > 0) {
                    setFormData(prev => ({
                        ...prev,
                        companyName: data.companyName || "",
                        businessVertical: data.businessVertical || "ENGINEERING_SERVICE",
                        position: data.position || "",
                        vendorType: data.vendorType || ""
                    }));
                }
            } catch (error) {
                console.error("Error fetching vendor data:", error);
            } finally {
                hideLoader();
            }
        };
        
        fetchVendorData();
    }, []);

    return (
        <div style={cardStyle}>
            <h3 style={sectionTitle}>Company Details</h3>

            <div style={rowStyle}>
                <div style={field}>
                    <label style={label}>Company Name *</label>
                    <input
                        style={input}
                        value={formData.companyName || ""}
                        onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
                        placeholder="Enter company name"
                    />
                </div>

                <div style={field}>
                    <label style={label}>Position</label>
                    <input
                        style={input}
                        value={formData.position || ""}
                        onChange={(e) => setFormData({ ...formData, position: e.target.value })}
                        placeholder="Enter position"
                    />
                </div>
            </div>

            <div style={rowStyle}>
                <div style={field}>
                    <label style={label}>Business Vertical *</label>
                    <select
                        style={input}
                        value={formData.businessVertical || ""}
                        onChange={(e) => setFormData({ ...formData, businessVertical: e.target.value })}
                    >
                        <option value="">Select business vertical</option>
                        <option value="ENGINEERING_SERVICE">Engineering Service</option>
                        <option value="MECHANICAL_SERVICE">Mechanical Services</option>
                        <option value="ELECTRICAL_SERVICE">Electrical Services</option>
                        <option value="CIVIL_SERVICE">Civil Services</option>
                        <option value="AUTOMATION_SERVICE">Automation Services</option>
                        <option value="MAINTENANCE_SERVICE">Maintenance Services</option>
                    </select>
                </div>

                <div style={field}>
                    <label style={label}>Business Type *</label>
                    <select
                        style={input}
                        value={formData.vendorType || ""}
                        onChange={(e) => setFormData({ ...formData, vendorType: e.target.value })}
                    >
                        <option value="">Select business type</option>
                        <option value="INDIVIDUAL">Individual</option>
                        <option value="PARTNERSHIP">Partnership</option>
                        <option value="PRIVATE_LIMITED">Private Limited</option>
                        <option value="PUBLIC_LIMITED">Public Limited</option>
                        <option value="LLP">LLP</option>
                    </select>
                </div>
            </div>

            <div style={buttonContainer}>
                <button style={nextBtn} onClick={onNext}>
                    Save & Next →
                </button>
            </div>
        </div>
    );
};

export default Profilemangement;

const cardStyle = {
    background: "#fff",
    borderRadius: "12px",
};

const sectionTitle = {
    fontSize: "16px",
    fontWeight: "600",
    marginBottom: "20px",
    color: "#111827"
};

const rowStyle = {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
    marginBottom: "15px"
};

const field = {
    flex: 1,
    minWidth: "200px"
};

const label = {
    fontSize: "13px",
    fontWeight: "600",
    marginBottom: "6px",
    display: "block",
    color: "#374151"
};

const input = {
    width: "100%",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    background: "#f9fafb",
    fontSize: "13px",
    boxSizing: "border-box"
};

const buttonContainer = {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "30px",
    paddingTop: "20px",
    borderTop: "1px solid #e5e7eb"
};

const nextBtn = {
    background: "#f97316",
    color: "#fff",
    padding: "10px 24px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "14px"
};